












import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Size } from "../../../domain/drawing";
import { IKeyHandleable } from "./IKeyHandleable";
import { default as CursorKeyHandler } from "./CursorKeyHandler.vue";
import { default as SelectAllKeyHandler } from "./SelectAllKeyHandler.vue";
import { default as DeleteKeyHandler } from "./DeleteKeyHandler.vue";
import { default as UndoKeyHandler } from "./UndoKeyHandler.vue";
import { default as RedoKeyHandler } from "./RedoKeyHandler.vue";
import { default as CopyKeyHandler } from "./CopyKeyHandler.vue";
import { default as PasteKeyHandler } from "./PasteKeyHandler.vue";

@Component({
  components: {
    CursorKeyHandler,
    SelectAllKeyHandler,
    DeleteKeyHandler,
    UndoKeyHandler,
    RedoKeyHandler,
    CopyKeyHandler,
    PasteKeyHandler,
  },
})
export default class StandardKeyboardHandler extends Mixins() {
  @Prop()
  isActive: boolean;

  @Prop({ default: () => new Size(10, 10) })
  gridSize: Size;

  @Prop()
  moving: (offest: Size) => boolean;

  @Prop()
  moved: (offest: Size) => boolean;

  @Prop()
  allSelected: () => boolean;

  @Prop()
  deleted: () => boolean;

  @Prop()
  undone: () => boolean;

  @Prop()
  redone: () => boolean;

  @Prop()
  copied: () => boolean;

  @Prop()
  pasted: () => boolean;

  $refs!: {
    cursor: CursorKeyHandler;
    selectAll: SelectAllKeyHandler;
    delete: DeleteKeyHandler;
    undo: UndoKeyHandler;
    redo: RedoKeyHandler;
    copy: CopyKeyHandler;
    paste: PasteKeyHandler;
  };

  get handlers(): IKeyHandleable[] {
    return [
      this.$refs.cursor,
      this.$refs.selectAll,
      this.$refs.delete,
      this.$refs.undo,
      this.$refs.redo,
      this.$refs.copy,
      this.$refs.paste,
    ];
  }

  mounted() {
    window.addEventListener("keydown", this.handleKeyDowned, false);
    window.addEventListener("keyup", this.handleKeyUpped, false);
  }

  destroyed() {
    window.removeEventListener("keydown", this.handleKeyDowned, false);
    window.removeEventListener("keyup", this.handleKeyUpped, false);
  }

  handleKeyDowned(event: KeyboardEvent): void {
    if (this.isKeyHandleable(event) && Enumerable.from(this.handlers).any(h => h.handleKeyDowned(event, this.isTargetInputtable(event), this.isTextSelecting(event)))) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  handleKeyUpped(event: KeyboardEvent): void {
    if (this.isKeyHandleable(event) && Enumerable.from(this.handlers).any(h => h.handleKeyUpped(event, this.isTargetInputtable(event), this.isTextSelecting(event)))) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  private isKeyHandleable(event: KeyboardEvent): boolean {
    return this.isActive
        && !this.isBeingModal();
  }

  private isTargetInputtable(event: Event): boolean {
    return (event.target instanceof HTMLTextAreaElement)
        || (event.target instanceof HTMLInputElement)
        || (event.target instanceof HTMLSelectElement)
        || (event.target instanceof HTMLElement && event.target.contentEditable === "true");  // QuillEditor対策
  }

  private isTextSelecting(event: Event): boolean {
    return ((event.target instanceof HTMLTextAreaElement) || (event.target instanceof HTMLInputElement))
        && event.target.selectionStart < event.target.selectionEnd;
  }

  private isBeingModal(): boolean {
    // PDF表示用なので名前がおかしいが...別途本体側修正する.
    return (0 < this.$store.state.pdfViewerVisibleControlObjects.length);
  }
}
